export const seeds = [
        {
            category: 'Cene mineralnog đubriva',
            text: 'Cene mineralnog đubriva u Srbiji',
            config: 'seedFer',
            subcategories:[
            {
                name: 'NPK',
                text: 'Cene NPG mineralnog đubriva'
            },
            {
                name: 'UREA',
                text: 'Cene UREA mineralnog đubriva'
            },
            {
                name: 'KAN',
                text: 'Cene KAN mineralnog đubriva'
            },
            {
                name: 'AN',
                text: 'Cene AN mineralnog đubriva'
            },
            {
                name: 'MAP',
                text: 'Cene MAP mineralnog đubriva'
            },
            {
                name: 'Slavol',
                text: 'Cene Slavol mineralnog đubriva'
            },
            {
                name: 'Murtonic',
                text: 'Cene Murtonic mineralnog đubriva'
            },
            {
                name: 'Wuxal',
                text: 'Cene Wuxal mineralnog đubriva'
            }
        ]
        },
        {
            category: 'Cene semena pšenice',
            text: 'Cene semena pšenice u Srbiji',
             config: 'seed',
            subcategories:[
                {
                    name: 'NS sve sorte (pšenica)',
                    text: 'Cene NS sve sorte semena za pšenicu'
                },
                {
                    name: 'LG sve sorte (pšenica)',
                    text: 'Cene LG sve sorte semena za pšenicu'
                },
                {
                    name: 'Ingenio',
                    text: 'Cene Ingenio semena za pšenicu'
                },
                {
                    name: 'Balaton',
                    text: 'Cene Balaton semena za pšenicu'
                },
            {
                name: 'SIRTAKI',
                text: 'Cene SIRTAKI semena za pšenicu'
            }

        ]
        },
        {
            category: 'Cene semena ječma',
            text: 'Cene semena ječma u Srbiji',
             config: 'seed',
            subcategories:[
                {
                    name: 'NS sve sorte (ječam)',
                    text: 'Cene NS sve sorte semena za ječam'
                },
                {
                    name: 'LG sve sorte (ječam)',
                    text: 'Cene LG sve sorte semena za ječam'
                },
                {
                    name: 'NONIUS',
                    text: 'Cene NONIUS semena za ječam'
                },
                {
                    name: 'PASO',
                       text: 'Cene PASO semena za ječam'
                   },
               {
                   name: 'TRITIKALE',
                   text: 'Cene TRITIKALE semena za ječam'
               }
   
           ]
           },
           {
               category: 'Cene semena krompira',
               text: 'Cene semena krompira u Srbiji',
                config: 'seed',
               subcategories: [
              {
                name: 'CLEOPATRA (CLEOPATRA) rana sorta original',
                text: 'Cene CLEOPATRA (CLEOPATRA) rana sorta-original semena za krompir'
              },
              {
                name: 'CLEOPATRA (CLEOPATRA) rana sorta i sortna reprodukcija',
                text: 'Cene CLEOPATRA (CLEOPATRA) rana sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'KARERA - srednje rana do srednje kasna sorta-original',
                text: 'Cene KARERA - srednje rana do srednje kasna sorta-original semena za krompir'
              },
              {
                name: 'KARERA - srednje rana do srednje kasna sorta i sortna reprodukcija',
                text: 'Cene KARERA - srednje rana do srednje kasna sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'RIVIJERA - original',
                text: 'Cene RIVIJERA - original semena za krompir'
              },
              {
                name: 'AGRIJA (AGRIA) - srednje kasna sorta - original',
                text: 'Cene AGRIJA (AGRIA) - srednje kasna sorta - original semena za krompir'
              },
              {
                name: 'AGRIJA (AGRIA) - srednje kasna sorta i sortna reprodukcija',
                text: 'Cene AGRIJA (AGRIA) - srednje kasna sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'ESME - srednje kasna sorta i sortna reprodukcija',
                text: 'Cene ESME - srednje kasna sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'ARIZONA - srednje kasna sorta i sortna reprodukcija',
                text: 'Cene ARIZONA - srednje kasna sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'BELLAROSA - veoma rana sorta i sortna reprodukcija',
                text: 'Cene BELLAROSA - veoma rana sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'DEZIRE (DESIREE) - srednje kasna sorta - original',
                text: 'Cene DEZIRE (DESIREE) - srednje kasna sorta - original semena za krompir'
              },
              {
                name: 'DEZIRE (DESIREE) - srednje kasna sorta i sortna reprodukcija',
                text: 'Cene DEZIRE (DESIREE) - srednje kasna sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'KENEBEK (KENNEBEC) - srednje kasna sorta - original',
                text: 'Cene KENEBEK (KENNEBEC) - srednje kasna sorta - original semena za krompir'
              },
              {
                name: 'KENEBEK (KENNEBEC) - srednje kasna sorta i sortna reprodukcija',
                text: 'Cene KENEBEK (KENNEBEC) - srednje kasna sorta i sortna reprodukcija semena za krompir'
              },
              {
                name: 'SIRTAKI',
                text: 'Cene SIRTAKI semena za krompir'
              }
            ]
           },
            {
               category: 'Cene semena kukuruza',
               text: 'Cene semena kukuruza u Srbiji',
                config: 'seed',
               subcategories: [
              {
                  name: 'PRIMA CENOVNA GRUPA',
                  text: 'Cene za PRIMU CENOVNU GRUPU semena'
                },
                {
                  name: 'I CENOVNA GRUPA',
                  text: 'Cene za I CENOVNU GRUPU semena'
                },
                {
                  name: 'II CENOVNA GRUPA',
                  text: 'Cene za II CENOVNU GRUPU semena'
                },
                {
                  name: 'III CENOVNA GRUPA',
                  text: 'Cene za III CENOVNU GRUPU semena'
                },
                {
                  name: 'IV CENOVNA GRUPA',
                  text: 'Cene za IV CENOVNU GRUPU semena'
                },
                {
                  name: 'CARIOCA',
                  text: 'Cene za seme sorte CARIOCA'
                },
                {
                  name: 'BILBAO',
                  text: 'Cene za seme sorte BILBAO'
                },
                {
                  name: 'ANDROMEDA',
                  text: 'Cene za seme sorte ANDROMEDA'
                },
                {
                  name: 'AGRISTER',
                  text: 'Cene za seme sorte AGRISTER'
                },
                {
                  name: 'ADVISIO',
                  text: 'Cene za seme sorte ADVISIO'
                },
                {
                  name: 'INTELIGENS',
                  text: 'Cene za seme sorte INTELIGENS'
                },
                {
                  name: 'SMARAGD',
                  text: 'Cene za seme sorte SMARAGD'
                },
                {
                  name: 'KASHMIR',
                  text: 'Cene za seme sorte KASHMIR'
                },
                {
                  name: 'MIKADO',
                  text: 'Cene za seme sorte MIKADO'
                },
                {
                  name: 'AS 54',
                  text: 'Cene za seme sorte AS 54'
                },
                {
                  name: 'AS 62, AS 72, AS 51',
                  text: 'Cene za sorte AS 62, AS 72 i AS 51 semena'
                }
            ]
           }
    ]
